import { Camera } from "~/_legacy/types/analysis";
import { compareAnalysisNumber, isNullish } from "./compare";

export const getSortedCameras = <T extends Camera>(cameras: T[]) => {
  return cameras.toSorted((a, b) => {
    if (!isNullish(a.analysisNumber) && !isNullish(b.analysisNumber)) {
      return compareAnalysisNumber(a.analysisNumber!, b.analysisNumber!);
    } else if (!isNullish(a.analysisNumber)) {
      return -1;
    } else if (!isNullish(b.analysisNumber)) {
      return 1;
    }
    if (!isNullish(a.pseudoCamera?.defaultCamId) && !isNullish(b.pseudoCamera?.defaultCamId)) {
      const parsedA = parseInt(a.pseudoCamera!.defaultCamId);
      const parsedB = parseInt(b.pseudoCamera!.defaultCamId);
      return parsedA - parsedB;
    } else if (!isNullish(a.pseudoCamera?.defaultCamId)) {
      return -1;
    } else if (!isNullish(b.pseudoCamera?.defaultCamId)) {
      return 1;
    } else {
      return 0;
    }
  });
};
